import { render, staticRenderFns } from "./data34.vue?vue&type=template&id=7c0929ca&scoped=true"
import script from "./data34.vue?vue&type=script&lang=js"
export * from "./data34.vue?vue&type=script&lang=js"
import style1 from "./data34.vue?vue&type=style&index=1&id=7c0929ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0929ca",
  null
  
)

export default component.exports